import React, {ReactNode, createContext, useRef} from 'react';

import {Refreshable, RefreshableTableContextType} from './types';

const RefreshableTableContext = createContext<RefreshableTableContextType>({} as RefreshableTableContextType);

const RefreshableTableProvider = ({children}: {children: ReactNode}): JSX.Element => {
    const ref = useRef<Refreshable>(null);

    return <RefreshableTableContext.Provider value={{ref}}>{children}</RefreshableTableContext.Provider>;
};

const useRefreshableTable = () => React.useContext(RefreshableTableContext);

export {RefreshableTableProvider, useRefreshableTable};
